import gql from 'graphql-tag';

export const contractorSendPassword = gql`
  mutation contractorSendPassword($contractor: IdInput!) {
    contractorSendPassword(contractor: $contractor) {
      success
    }
  }
`;
